const DISPLAY_DECIMALS = 2;
const EMPTY_AMOUNT = '—';
const EMPTY_TEXT = '';

export function payrollNumberDisplay(value: string | number | null, money: boolean = false): string {
  if (value === null || value === undefined) { return EMPTY_AMOUNT; }
  if (value === EMPTY_TEXT || !isFinite(Number(value))) { return String(value); }
  const formatted = Number(value).toFixed(DISPLAY_DECIMALS);
  return money ? formatted : String(Number(formatted));
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/payroll-number-display.ts